export function getFreddyLabels(componentName, t) {
    const translations = {
        breadcrumbs: () => ({
            ariaLabel: t('ariaLabel'),
        }),
        carousel: () => ({
            ariaLabelPrev: t('ariaLabelPrev'),
            ariaLabelNext: t('ariaLabelNext'),
        }),
        collapse: () => ({
            labelCollapsed: t('labelCollapsed'),
            labelExpanded: t('labelExpanded'),
        }),
        drawer: () => ({
            ariaLabelClose: t('ariaLabelClose'),
        }),
        modal: () => ({
            ariaLabelClose: t('ariaLabelClose'),
        }),
        pagination: () => ({
            ariaLabelPagination: t('ariaLabelPagination'),
            ariaLabelGoTo: t('ariaLabelGoTo'),
            ariaLabelNext: t('ariaLabelNext'),
            ariaLabelPrev: t('ariaLabelPrev'),
            labelNext: t('labelNext'),
            labelPrev: t('labelPrev'),
        }),
        passwordStrengthIndicator: () => ({
            labelStrengthIndicator: t('labelStrengthIndicator'),
            description: t('description'),
        }),
        popover: () => ({
            ariaLabelClose: t('ariaLabelClose'),
        }),
        reviewRating: () => ({
            ariaLabelRating: t('ariaLabelRating'),
            ariaLabelReviewCountSingular: t('ariaLabelReviewCountSingular'),
            ariaLabelReviewCountPlural: t('ariaLabelReviewCountPlural'),
            labelFirstReview: t('labelFirstReview'),
            labelReviewSingular: t('labelReviewSingular'),
            labelReviewPlural: t('labelReviewPlural'),
            labelEmphasizedSingular: t('labelEmphasizedSingular'),
            labelEmphasizedPlural: t('labelEmphasizedPlural'),
        }),
        tabs: () => ({
            ariaLabelPrev: t('ariaLabelPrev'),
            ariaLabelNext: t('ariaLabelNext'),
        }),
        map: () => ({
            ariaLabelZoomIn: t('ariaLabelZoomIn'),
            ariaLabelZoomOut: t('ariaLabelZoomOut'),
            ariaLabelPanUp: t('ariaLabelPanUp'),
            ariaLabelPanDown: t('ariaLabelPanDown'),
            ariaLabelPanLeft: t('ariaLabelPanLeft'),
            ariaLabelPanRight: t('ariaLabelPanRight'),
            ariaLabelShowPan: t('ariaLabelShowPan'),
            ariaLabelHidePan: t('ariaLabelHidePan'),
            ariaLabelEnterFullscreen: t('ariaLabelEnterFullscreen'),
            ariaLabelExitFullscreen: t('ariaLabelExitFullscreen'),
        }),
    };
    return translations[componentName]();
}
//# sourceMappingURL=getFreddyLabels.js.map